import { ref, reactive } from 'vue'
import { _firestoreCuenta, petición } from '@/../../cliente_comun/fuentes'
import { notificación, manejarCambiosFirebase } from '@/../../cliente_comun/utilidades'

/**
 * @typedef PuntoDeVenta
 * @type {object}
 * @property {string} nombre - Nombre.
 * @property {string} descripción - Descripción.
 * @property {string} códigoDeAcceso - Código de acceso desde punto de venta.
 */

export const listadoDePuntosDeVenta = ref([])

export const guardandoPuntoDeVenta = ref(false)
export const listandoPuntosDeVenta = ref(false)

let desconectarListado = null

/** @type {PuntoDeVenta} */
export const puntoDeVenta = reactive({
	nombre: '',
	descripción: '',
	códigoDeAcceso: '',
})

export async function inicializarListado() {
	if (desconectarListado) {
		return
	}

	listadoDePuntosDeVenta.value = []
	listandoPuntosDeVenta.value = true
	desconectarListado = _firestoreCuenta.collection('puntosDeVenta').orderBy('creación.fecha', 'desc').onSnapshot( snapshot => {
		manejarCambiosFirebase(listadoDePuntosDeVenta.value, snapshot, { agregarAlInicio: true })
		listandoPuntosDeVenta.value = false
	})
}

function _verificarDatos() {
	puntoDeVenta.nombre = (puntoDeVenta.nombre || '').trim()
	puntoDeVenta.descripción = (puntoDeVenta.descripción || '').trim()
	puntoDeVenta.códigoDeAcceso = (puntoDeVenta.códigoDeAcceso || '').trim()

	if (!puntoDeVenta.nombre) {
		notificación.error('Falta el nombre.')
		throw false
	}

	return puntoDeVenta
}

/**
 * 
 * @param {string | null} identificador 
 * @returns 
 */
export async function guardarPuntoDeVenta(identificador) {
	_verificarDatos()

	let P = null
	if (identificador) {
		P = petición.put(`/administracion/v1/puntos-de-venta/${identificador}`, puntoDeVenta)
	} else {
		P = petición.post('/administracion/v1/puntos-de-venta', puntoDeVenta)
	}

	guardandoPuntoDeVenta.value = true
	return P.then(() => {
		notificación.correcto('Punto de venta guardado.')
		guardandoPuntoDeVenta.value = false
		limpiarObjeto()
	}).catch(() => {
		guardandoPuntoDeVenta.value = false
		return Promise.reject()
	})
}

export function desconectar() {
	if (desconectarListado) {
		desconectarListado()
		desconectarListado = null
	}

	listadoDePuntosDeVenta.value = []
	limpiarObjeto()
}

export function limpiarObjeto() {
	puntoDeVenta.nombre = ''
	puntoDeVenta.descripción = ''
	puntoDeVenta.códigoDeAcceso = ''
}
